import React from 'react';
import { Box } from '@mui/material';
import PremiumChatInput from 'components/chat/PremiumChatInput';
import ImageAttachments from 'components/chat/ImageAttachments';

const ChatInputBar = ({
  onSendMessage,
  showTyping,
  autoFocus = false,
  compact = false,
  actionsPlacement,
  menuZIndex,
  imageAttachments,
  onChangeImageAttachments,
  onStop,
  noTopPadding = false,
  noBottomPadding = false,
  dense = false,
  placeholder = 'Ask anything...',
  value,
  onChangeValue,
  disableVoice = false,
  disableAttachments = false,
  minRowsOverride,
  allowEmptySend = false
}) => {
  return (
    <Box>
      {typeof imageAttachments !== 'undefined' && typeof onChangeImageAttachments === 'function' && (
        <ImageAttachments value={imageAttachments} onChange={onChangeImageAttachments} />
      )}
      <PremiumChatInput
        onSendMessage={onSendMessage}
        placeholder={placeholder}
        showTyping={showTyping}
        autoFocus={autoFocus}
        compact={compact}
        suggestions={[]}
        disableInlineSuggestions
        onStop={onStop}
        noTopPadding={noTopPadding}
        noBottomPadding={noBottomPadding}
        dense={dense}
        {...(actionsPlacement ? { actionsPlacement } : {})}
        {...(menuZIndex ? { menuZIndex } : {})}
        showLeftPlus={!compact}
        externalValue={value}
        onChangeMessage={onChangeValue}
        disableVoice={disableVoice}
        disableAttachments={disableAttachments}
        minRowsOverride={minRowsOverride}
        allowEmptySend={allowEmptySend}
      />
    </Box>
  );
};

export default ChatInputBar;
